import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Input, Select, Steps, Row, Col, Descriptions } from 'antd'
import get from 'lodash/get'
import * as actions from '../../actions/creditCardAction'
import TokenForm from './TokenForm'
import PrismCode from '../Tokenization/PrismCode'
import { generateRef, qrText } from '../../common/Utils'
import { withTranslation } from "react-i18next";

const { Step } = Steps;

const codeResponse1 = `
{
  "resultCode": "00",
  "rememberCard": false,
  "card": {
    "number": "453501XXXXXX5741",
    "expirationMonth": "05",
    "expirationYear": "28",
    "name": "Card Test UAT (Server Test)",
    "token": "94a08da1fecbb6e8b46990538c7b50b2"
  }
}
`

const codeResponse2 = `
{
  "resultCode": "00",
  "rememberCard": false,
  "card": {
    "number": "453501XXXXXX5741",
    "expirationMonth": "02",
    "expirationYear": "25",
    "name": "Card Test UAT (Server Test)",
    "token": "94a08da1fecbb6e8b46990538c7b50b2"
  }
}
`

const renderFormCodeCard1Response = data => {
  return (
    <div>
      <PrismCode
        code={codeResponse1}
        language="json"
        plugins={["line-numbers"]}
      />
    </div>
  )
}

const renderFormCodeCard2Response = data => {
  return (
    <div>
      <PrismCode
        code={codeResponse2}
        language="json"
        plugins={["line-numbers"]}
      />
    </div>
  )
}

class TokenDemo extends Component {
  state = {
    currentStep: 0,
    otp: ''
  }
  componentDidMount() {
    this.props.updateByKey('referenceNo', generateRef())
  }
  changeStep = current => {
    this.setState({ currentStep: current })
  }
  changeStepPrev = () => {
    this.setState({ currentStep: this.state.currentStep - 1 })
  }
  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  render() {
    const { t , i18n } = this.props;
    return (
      <>
        <p style={{color: 'rgba(0, 0, 0, 0.85)', marginTop: 10 }}>Result</p>
        <Steps size="small" current={this.state.currentStep}>
          <Step title="Create" />
          <Step title="Response" />
        </Steps>

        <div className="steps-content">
          { this.state.currentStep === 0 && (
            <Row>
              <Col sm={7} md={8}>
                {' '}
              </Col>
              <Col sm={10} md={8}>
                <TokenForm
                  updateByKey={this.props.updateByKey}
                  onSubmit={() => this.changeStep(1)}
                  loading={this.props.creditCard.loading}
                  token={get(this.props, 'creditCard.tokenResp.card.token', undefined)}
                  data={this.props.creditCard}
                />
              </Col>
              <Col sm={7} md={8}>
                {' '}
              </Col>
            </Row>
            )}

            { this.state.currentStep === 1 && (
              <>
                <Row>
                  <Col sm={2} md={4}>
                    {' '}
                  </Col>
                  <Col sm={20} md={16}>
                    <p style={{ color: 'rgba(0, 0, 0, 0.85)', fontWeight: 'bold', textAlign: 'left' }}>Data Response</p>
                    {console.log('this.props.creditCard.cardNumber', this.props.creditCard.cardNumber)}
                    {this.props.creditCard.cardNumber === '4535017710535741' ? renderFormCodeCard1Response(this.props.qrCash) : renderFormCodeCard2Response(this.props.qrCash)}
                    <br/>
                  </Col>
                  <Col sm={2} md={4}>
                    {' '}
                  </Col>
                </Row>
                <Row>
                  <Col sm={5} md={8}>
                    {' '}
                  </Col>
                  <Col sm={14} md={8}>
                    <Button type="primary" onClick={() => this.changeStep(0)} block>Done</Button><br/>
                    <Button style={{ marginTop: 8 }} onClick={this.changeStepPrev} block>
                      Previous
                    </Button>
                  </Col>
                  <Col sm={5} md={8}>
                    {' '}
                  </Col>
                </Row>
              </>
            )}
          </div>
          <br />
          <Descriptions title={t("tokenapi:cardtestuat")} size={'default'}>
            <Descriptions.Item label="Card Number">4535 0177 1053 5741</Descriptions.Item>
            <Descriptions.Item label="MM/YY">05/28</Descriptions.Item>
            <Descriptions.Item label="CVV">184</Descriptions.Item>
          </Descriptions>
          <br />

          <Descriptions title={t("tokenapi:cardtestuat")} size={'default'}>
            <Descriptions.Item label="Card Number">5258 8606 8990 5862</Descriptions.Item>
            <Descriptions.Item label="MM/YY">02/25</Descriptions.Item>
            <Descriptions.Item label="CVV">950</Descriptions.Item>
          </Descriptions>
      </>
    )
  }
}
const mapStateToProps = state => ({
  creditCard: state.creditCard
})
const mapDispatchToProps = dispatch => ({
  updateByKey: (key, value) => dispatch(actions.updateByKey(key, value))
})
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(TokenDemo)
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TokenDemo));